module.exports = __webpack_public_path__ + "static/media/UnlistedSchool.4f55be0a.png";